/*
  NAAMANE welkomstkorting: houdt bij wanneer iemand zich heeft ingeschreven en toont een echte aftelklok.
  De code (bijv. INSIDER10) werkt in Shopify alleen voor nieuwe inschrijvers zonder bestelling,
  tot 2 kalenderdagen na inschrijven. De klok hier telt 48 uur af en loopt dus nooit achter op Shopify.
  1-11: wordt op elke pagina geladen (ook winkelwagen). Toont duidelijk dat de korting automatisch
  van de winkelwagen afgaat: balk in de winkelwagen (lade en pagina) en een -10% label bij het winkelwagentje.
*/
(() => {
  if (window.NmWelcome) return;
  const KEY = 'nm-welcome';
  const pad = (n) => String(n).padStart(2, '0');

  const NmWelcome = {
    get() {
      try {
        const c = JSON.parse(localStorage.getItem(KEY) || 'null');
        return c && c.code && c.until ? c : null;
      } catch (e) {
        return null;
      }
    },
    active() {
      const c = this.get();
      return c && c.until > Date.now() ? c : null;
    },
    start(code, hours) {
      const current = this.active();
      if (current && current.code === code) return current;
      const claim = { code, until: Date.now() + Math.max(1, Number(hours) || 48) * 36e5 };
      try { localStorage.setItem(KEY, JSON.stringify(claim)); } catch (e) {}
      return claim;
    },
    format(ms) {
      const s = Math.max(0, Math.floor(ms / 1000));
      return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
    },
    /* staat de code in de winkelwagen? (cookie van /discount/CODE of de kortingsregel in de winkelwagen) */
    applied(code) {
      if (!code) return false;
      const c = code.toUpperCase();
      try {
        const m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
        if (m && decodeURIComponent(m[1]).toUpperCase().split(',').map((s) => s.trim()).includes(c)) return true;
      } catch (e) {}
      return [...document.querySelectorAll('.cart-discounts__label, .cart-discount__label, .cart-discounts__item')]
        .some((el) => (el.textContent || '').toUpperCase().includes(c));
    },
  };
  /* korting meteen in de winkelwagen zetten zodra iemand is ingeschreven (geen knop nodig).
     Licht verzoek zonder doorsturen: Shopify zet de cookie en koppelt de code aan de winkelwagen. */
  let ensured = false;
  NmWelcome.ensure = function (code) {
    if (ensured || !code || this.applied(code)) return;
    ensured = true;
    try {
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' })
        .then(() => { if (window.NmWelcomeSync) setTimeout(window.NmWelcomeSync, 300); })
        .catch(() => {});
    } catch (e) {}
  };
  window.NmWelcome = NmWelcome;

  class NmWelcomeTimer extends HTMLElement {
    connectedCallback() {
      this.tick();
      this._t = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }
    tick() {
      const claim = NmWelcome.get();
      if (!claim) return; /* nog niet gestart: servertekst laten staan */
      const left = claim.until - Date.now();
      this.textContent = NmWelcome.format(left);
      if (left <= 0) {
        clearInterval(this._t);
        this.dispatchEvent(new CustomEvent('nm-welcome-expired', { bubbles: true }));
      }
    }
  }
  if (!customElements.get('nm-welcome-timer')) customElements.define('nm-welcome-timer', NmWelcomeTimer);

  /* Balk in de winkelwagen. Toegepast: "10% Insider-korting toegepast" + klok. Nog niet: knop Toepassen. */
  const CODE_FALLBACK = 'INSIDER10';
  const barHTML = (claim, applied) => {
    const code = (claim && claim.code) || CODE_FALLBACK;
    const href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    if (applied) {
      return `<p class="nm-wb2__main"><span class="nm-wb2__check" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5.2l2.3 2.3L8.6 2.5" stroke="#0b0b0b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Je 10% Insider-korting is toegepast</p>`
        + `<p class="nm-wb2__sub">Automatisch van je totaal afgetrokken${claim ? ` &middot; nog <nm-welcome-timer>${NmWelcome.format(claim.until - Date.now())}</nm-welcome-timer> geldig` : ''}</p>`;
    }
    return `<p class="nm-wb2__main">Je 10% Insider-korting staat klaar</p>`
      + `<p class="nm-wb2__sub">Nog <nm-welcome-timer>${NmWelcome.format(claim.until - Date.now())}</nm-welcome-timer> geldig. Eén klik en hij gaat automatisch van je totaal af.</p>`
      + `<a class="nm-wb2__apply" href="${href}">Korting toepassen</a>`;
  };
  class NmWelcomeBar extends HTMLElement {
    connectedCallback() { this.render(); this.addEventListener('nm-welcome-expired', () => this.render()); }
    render() {
      const claim = NmWelcome.active();
      const code = (claim && claim.code) || CODE_FALLBACK;
      const applied = NmWelcome.applied(code);
      if (!claim && !applied) { this.hidden = true; return; }
      const state = applied ? 'on' : 'ready';
      if (this.dataset.state === state && this.firstElementChild && this.firstElementChild.classList.contains('nm-wb2__main')) { this.hidden = false; return; }
      this.dataset.state = state;
      this.classList.add('nm-wb2');
      this.classList.toggle('nm-wb2--on', applied);
      this.innerHTML = barHTML(claim, applied);
      this.hidden = false;
    }
  }
  if (!customElements.get('nm-welcome-bar')) customElements.define('nm-welcome-bar', NmWelcomeBar);

  const css = `
    nm-welcome-bar.nm-wb2 { display: block; margin: 10px 0 12px; padding: 14px 16px; background: #0b0b0b; color: #fff; border: 1px solid rgb(255 255 255 / 0.18); border-radius: 14px; text-align: left; }
    nm-welcome-bar.nm-wb2[hidden] { display: none; }
    .cart-drawer__inner nm-welcome-bar.nm-wb2 { margin: 8px 14px 12px; }
    .nm-wb2__main { margin: 0; font-family: var(--nm-mono, monospace); font-size: 12px; letter-spacing: 0.1em; text-transform: uppercase; line-height: 1.4; }
    .nm-wb2__check { display: inline-grid; place-items: center; width: 18px; height: 18px; margin-right: 4px; border-radius: 50%; background: #fff; color: #0b0b0b; font-size: 11px; letter-spacing: 0; vertical-align: -3px; }
    .nm-wb2__sub { margin: 6px 0 0; font-family: var(--nm-sans, sans-serif); font-size: 12.5px; line-height: 1.45; color: rgb(255 255 255 / 0.78); letter-spacing: 0; text-transform: none; }
    .nm-wb2__sub nm-welcome-timer { font-family: var(--nm-mono, monospace); font-variant-numeric: tabular-nums; color: #fff; }
    .nm-wb2__apply { display: inline-flex; align-items: center; justify-content: center; margin-top: 10px; min-height: 40px; padding: 0 18px; border-radius: 999px; background: #fff; color: #0b0b0b !important; text-decoration: none; font-family: var(--nm-mono, monospace); font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; }
    .nm-cart-tag { position: absolute; left: 50%; bottom: -9px; transform: translateX(-50%); z-index: 2; padding: 1px 5px; border-radius: 999px; background: #0b0b0b; color: #fff; border: 1px solid #fff; font-family: var(--nm-mono, monospace); font-size: 8.5px; line-height: 1.3; letter-spacing: 0.04em; white-space: nowrap; pointer-events: none; }
    .nm-ins__auto { margin: 0; padding: 10px 12px; background: #f2f2f2; font-size: 12.5px; line-height: 1.45; }
    .nm-ins__auto strong { font-weight: 600; }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  const sync = () => {
    const claim = NmWelcome.active();
    const code = (claim && claim.code) || CODE_FALLBACK;
    const applied = NmWelcome.applied(code);
    if (claim && !applied) NmWelcome.ensure(claim.code);
    /* bestaande balken opnieuw beoordelen (lade wordt na elke wijziging opnieuw opgebouwd) */
    document.querySelectorAll('nm-welcome-bar').forEach((b) => b.render && b.render());
    /* winkelwagenpagina: balk bovenaan de samenvatting */
    if (claim || applied) {
      document.querySelectorAll('.cart-summary__inner').forEach((inner) => {
        if (inner.closest('.cart-drawer__inner')) return;
        if (inner.querySelector(':scope > nm-welcome-bar')) return;
        inner.prepend(document.createElement('nm-welcome-bar'));
      });
    }
    /* -10% label bij het winkelwagentje rechtsboven */
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach((icon) => {
      const host = icon.closest('cart-icon') || icon;
      let tag = host.querySelector('.nm-cart-tag');
      if (applied) {
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'nm-cart-tag';
          tag.textContent = '-10%';
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          host.appendChild(tag);
        }
      } else if (tag) {
        tag.remove();
      }
    });
  };
  let queued = false;
  const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; sync(); }); };
  const startSync = () => {
    sync();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startSync); else startSync();
  window.NmWelcomeSync = sync;
})();

/* Insider-popup: na inschrijven (ook via de footer) de popup met de code direct openen.
   De korting staat dan al in de winkelwagen (NmWelcome.ensure); de knop in de popup sluit alleen.
   1-11: eerst stuurde de knop door of haalde hij de korting op en sloot dan; op iPhone liep dat vast. */
(() => {
  if (window.__nmInsPatch) return;
  window.__nmInsPatch = true;
  const run = () => {
    const ins = document.querySelector('nm-insider');
    if (!ins) return;
    const dialog = ins.querySelector('dialog');
    if (ins.querySelector('[data-success]') && dialog) {
      setTimeout(() => {
        if (!dialog.open && !document.querySelector('dialog[open]')) { try { dialog.showModal(); } catch (e) {} }
      }, 400);
    }
    /* de oude link-knop vervangen door uitleg + een sluitknop (de dialog sluit via [data-close]) */
    ins.querySelectorAll('a.nm-ins__submit[href*="/discount/"]').forEach((a) => {
      const p = document.createElement('p');
      p.className = 'nm-ins__auto';
      p.innerHTML = '<strong>Je hoeft niets te doen.</strong> De 10% staat al in je winkelwagen en gaat automatisch van je totaal af.';
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'button nm-ins__submit';
      b.setAttribute('data-close', '');
      b.textContent = 'Sluiten';
      a.replaceWith(p, b);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
